import { AttachmentBlockAttachmentType } from 'common/builder/blocks/blockConstants'
import { IAttachmentBlock, IBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartAttachmentPreviewBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachmentPreviewBlock'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { BlockType } from 'common/builder/constants/BlockType'
import { IUploadedImage } from 'common/builder/entityInterfaces'

export const AttachmentPreviewBlockGenericConverterRule: ConverterRule<
  IAttachmentBlock,
  FlowChartAttachmentPreviewBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) =>
    entity?.type === BlockType.ATTACHMENT &&
    entity?.attachment?.type === AttachmentBlockAttachmentType.IMAGE &&
    Boolean(entity?.attachment?.image_size),
  convert: (entity: IAttachmentBlock, { fields, flowChartButtons }) => {
    const image = entity.attachment as IUploadedImage

    return {
      id: entity.id,
      type: FlowChartBlockType.ATTACHMENT_PREVIEW,
      data: {
        preview: {
          url: replaceFieldsInString(image.img_big, fields),
          size: {
            width: image.image_size.width,
            height: image.image_size.height,
          },
        },
        buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
      },
    }
  },
}
